import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * useSiteContent(prefix)
 *
 * Fetches site content values with the given prefix (e.g. "sanctuary.")
 * and returns a helper `t(key, fallback)` that reads a value or falls
 * back to the hardcoded default if the admin hasn't edited it.
 *
 * Keys stored in the backend are the FULL key (e.g. "sanctuary.hero.title"),
 * but callers pass the SHORT key ("hero.title") to keep JSX readable —
 * so we prepend the prefix on lookup.
 *
 * Example:
 *   const t = useSiteContent('sanctuary.');
 *   return <h1>{t('hero.title', 'The Sanctuary')}</h1>;
 */
export function useSiteContent(prefix = '') {
  const [content, setContent] = useState({});
  useEffect(() => {
    const params = prefix ? { prefix } : {};
    api.get('/site-content', { params }).then(({ data }) => setContent(data || {})).catch(() => {});
  }, [prefix]);
  return (key, fallback = '') => {
    // Try the full key first (prefix + short key), then the short key alone
    // (supports both short-key and no-prefix usage).
    const value = content[prefix + key] ?? content[key];
    return (value === undefined || value === null || value === '') ? fallback : value;
  };
}
